import { GetterTree } from "vuex";
import * as types from "@/store/constants/types";
import * as constants from "@/store/constants/casinoConstants";
import { casino } from "@/api/http/gx/gxUser";

const Getters: GetterTree<any, any> = {
  [types.GETTER_CASINO_REMAIN_AND_DEAD_LINE](state, getters, rootState) {
    return (way: string, game: string) => {
      const serviceTime = rootState.gxUserInfoModule.gxUserInfo.server_current_time;
      const currentTime: number = Math.max(serviceTime ? serviceTime :0, new Date().valueOf());
      const { casinoConfig, casinoLimit } = getters[types.GETTER_CASINO_CONFIG_AND_LIMIT](game);

      if (way === constants.CASINO_FREE_WAY) {
        if (casinoLimit && casinoLimit.free_deadline && casinoLimit.free_deadline > currentTime) {
          return {
            remain: casinoLimit.free_remain,
            deadline: casinoLimit.free_deadline
          };
        } else {
          return {
            remain: casinoConfig.free_chance,
            deadline: 7918323936000
          };
        }
      } else if (way === constants.CASINO_EXTRA_WAY) {
        if (casinoLimit && casinoLimit.extra_deadline && casinoLimit.extra_deadline > currentTime) {
          return {
            remain: casinoLimit.extra_remain,
            deadline: casinoLimit.extra_deadline
          };
        } else {
          return {
            remain: casinoConfig.extra_chance,
            deadline: 7918323936000
          };
        }
      } else if (way === constants.CASINO_DOUBLE_WAY) {
        if (casinoLimit && casinoLimit.double_deadline && casinoLimit.double_deadline > currentTime) {
          return {
            remain: casinoLimit.double_remain,
            deadline: casinoLimit.double_deadline
          };
        } else {
          return {
            remain: casinoConfig.double_chance,
            deadline: 7918323936000
          };
        }
      }
    };
  },

  [types.GETTER_CASINO_TAB_INDEX](state, getters, rootState) {
    return state.casinoTabIndex;
  },
  [types.GETTER_CASINO_CONFIG_AND_LIMIT](state, getters, rootState) {
    return (game: string) => {
      const { gxUserInfoModule, settingModule } = rootState;
      const { settingData } = settingModule;
      const { gxUserInfo } = gxUserInfoModule;

      let casinoConfig: any;
      let casinoLimit: any;

      if (game === constants.CASINO_GAME_SLOTS) {
        casinoConfig = settingData.casino_config_slots;
        casinoLimit = gxUserInfo.slots_config;
      } else if (game === constants.CASINO_GAME_SPIN) {
        casinoConfig = settingData.casino_config_spin;
        casinoLimit = gxUserInfo.spin_config;
      } else if (game === constants.CASINO_GAME_DICE) {
        casinoConfig = settingData.casino_config_sic_bo;
        casinoLimit = gxUserInfo.sic_bo_config;
      }
      return { casinoConfig, casinoLimit };
    };
  },

  [types.GETTER_CASINO_REWARD_LIST](state, getters, rootState) {
    return (game: string) => {
      const { settingModule } = rootState;
      const { settingData } = settingModule;
      if (!settingData) {
        return undefined;
      }
      if (game === constants.CASINO_GAME_SLOTS) {
        return settingData.casino_slots;
      } else if (game === constants.CASINO_GAME_SPIN) {
        return settingData.casino_spin;
      } else if (game === constants.CASINO_GAME_DICE) {
        return settingData.casino_sic_bo;
      }
      return undefined;
    };
  },

  [types.GETTER_CASINO_HIGHEST_REWARD](state, getters, rootState) {
    return (game: string) => {
      const list: any = getters[types.GETTER_CASINO_REWARD_LIST](game);
      if (list && list.length > 0) {
        let largest = list[0];
        list.forEach((item: any) => {
          if (item.reward && item.reward > largest.reward) {
            largest = item;
          }
        });
        return largest;
      }

      return undefined;
    };
  },
  [types.GETTER_CASINO_ENABLED](state, getters, rootState) {
    const settingData: any = getters[types.GETTER_SETTING_DATA];
    console.log('抽奖开关', settingData &&
      settingData.casino_config_sic_bo &&
      settingData.casino_config_slots &&
      settingData.casino_config_spin &&
      settingData.enable &&
      settingData.enable.casino &&
      settingData.enable.casino === true)
    return (
      settingData &&
      settingData.casino_config_sic_bo &&
      settingData.casino_config_slots &&
      settingData.casino_config_spin &&
      settingData.enable &&
      settingData.enable.casino &&
      settingData.enable.casino === true
    );
  },

  [types.GETTER_TIPS_STATE](state) {
    return state.tipsObj;
  },

  // 获取当前距离可以free点击的倒计时
  [types.GETTER_CASINO_DEADLINE_BY_NAME](state, getters, rootState) {
    return (name: string) => {
      const gxUserInfo: any = rootState.gxUserInfoModule.gxUserInfo;
      let result = '';
      if (gxUserInfo[name] && gxUserInfo[name].free_remain === 0 && gxUserInfo[name].free_deadline > new Date().getTime()) {
        result = gxUserInfo[name].free_deadline;
      }
      return result;
    }
  }
};
export default Getters;
